import React from 'react'
import PropTypes from 'prop-types'
import { DebounceInput } from 'react-debounce-input'
import { Formik, Form, Field } from 'formik'
import { FieldGroup } from '@modules/form/form.module'
import FormikAutoSave from '@components/FormikAutoSave/FormikAutoSave'
import objectPath from 'object-path'
// import Debug from '@components/Debug/Debug'

import Select from './Select'

const flattenSelectValues = (values) =>
	Object.entries(values).reduce((o, [key, formValue]) => {
			const value = formValue && formValue.value
				? formValue.value
				: formValue;
			return {...o, [key]: value}
	}, {})

export default class TableFilters extends React.Component {
	
	static propTypes = {
		filters: PropTypes.arrayOf(PropTypes.object).isRequired,
		currentQuery: PropTypes.object,
		onChangeSearch: PropTypes.func,
		onChangeFilter: PropTypes.func,
	};

	onSave(values) {
		const { onChangeFilter } = this.props;
		
		// flatten select values
		var cleanedValues = flattenSelectValues(values);

		// // update filter query
		onChangeFilter(cleanedValues);
	}

	render() {
		const { onChangeSearch, onChangeFilter, filters, currentQuery } = this.props;
		const filterNullValues = filters.reduce((o, filter) => ({...o, [filter.name]: filter.nullValue}), {});
		const initialValues = {...filterNullValues, ...currentQuery};

		if(!this._rendered) {
			// TODO: make value ajax init work for ResourceIDSelect and remove this hacky workaround
			// this will reset filters on first render
			delete initialValues.client;
			delete initialValues.jobType;
			delete initialValues.jobTypes;
			delete initialValues.approvedBy
			this._rendered = true;
		}


		// console.log(filters);
		// console.log(initialValues);

		// initialValues.client = null;
		
		if(!filters || !filters.length) 
			return '';

		return (
			<div className="TableFilters">
				
				<b>Filters</b>

				<Formik initialValues={initialValues}>
					{(formik) => (
						<div className="TableFilters-form">
							{ this.renderFilters(formik) }
							<FormikAutoSave onSave={::this.onSave} />
						</div>
					)}

				</Formik>

			</div>
		);
	}


	renderFilters({ values, setFieldValue }) {
		const { filters } = this.props;
		return filters.map(filter => {
			const { nullValue, ...fieldArgs } = filter;
			const value = objectPath.get(values, filter.name);
			const hasValue = value != null && value !== nullValue;

			return (
				<div className="Filter" key={filter.name}>
					<FieldGroup key={filter.name} {...fieldArgs} />
					{ hasValue &&
						<button className="Filter-clearBtn" type="button" onClick={e => setFieldValue(filter.name, nullValue)}>clear</button>
					}
				</div>
			)
		});

	}

}



// WEBPACK FOOTER //
// ./src/components/DataTable/components/TableFilters.jsx